import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ChatModel } from '@models/chat.model'
import { ConfigService } from '@app/services'

declare var cordova: any
declare var window: any

@Component({
    selector: 'app-chat-item',
    templateUrl: './chat-item.component.html',
    styleUrls: ['./chat-item.component.css'],
})
export class ChatItemComponent implements OnInit {
    @Input() itemChat: ChatModel
    @Input() chatTagsObj: any[]
    @Input() visibleChatTags: any
    @Input() staffList
    @Input() index
    @Output() _onShowImage: EventEmitter<any> = new EventEmitter<any>()
    doctorName: any
    doctorNameDeleted
    staffName: any
    staffNameDeleted

    constructor(public configService: ConfigService) {
    }

    ngOnInit() {
        if (this.configService.config) {
            this.doctorName = this.configService.getDoctorName(this.itemChat['doctor'])
            this.doctorNameDeleted = this.configService.getDoctor(this.itemChat['doctor']).deleted
            //  this.staffName = this.configService.getStaffName(this.itemChat['staff'])
            //  this.staffNameDeleted = this.configService.getStaff(this.itemChat['staff']).deleted
        }
        const staff =  this.staffList.filter(s => s._id === this.itemChat['staff'])[0]
        const names = [staff ? staff['firstName'] : '', staff ? staff['familyName'] : '']
        this.staffName = names.filter(i => !!i).join(' ')
        this.staffNameDeleted = staff && staff.deleted ? staff.deleted : false
    }

    onShowImage() {
        this._onShowImage.emit()
    }

    linkUrl(event) {
        if (event.target.tagName.toLowerCase() === 'a') {
            event.stopPropagation()
            var el = event.target || event.srcElement
            cordova.InAppBrowser.open(el.getAttribute('href'), '_system', 'location=yes')
        }
    }

    scrollTo($event: MouseEvent, communicationId: any) {
        event.stopPropagation()
        const elementId = 'chat_' + communicationId
        setTimeout(() => {
            if (document.getElementById(elementId)) {
                document.getElementById(elementId).scrollIntoView()
            } else {
                console.warn('element not found', elementId)
            }
        }, 50)
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/app-component/chat-item/chat-item.component.ts